import { AI_ASSIST_CARD_LEDE, AI_ASSIST_IMPORTS } from "./aiAssistCopy";

/** Keep in sync with organizationBilling.ts and migration 075. */
export const TOURNAMENT_CAPS = {
  free: 5,
  ai_assist: 20,
  priority: null,
};

export const planFeatureText = (line) =>
  typeof line === "string" ? line : line?.label || "";

export const PLAN_TIERS = [
  {
    name: "Free",
    price: "$0",
    period: "",
    notes: ["Run tournaments free. AI Assist is free on your first one."],
    points: [
      "Up to 5 tournaments per year",
      "Online signups and Pay now",
      "Track the tournament and side pots on Scoring",
      "Brackets from the games you post",
      "Lock payouts on Finance and export checks",
    ],
  },
  {
    name: "AI Assist",
    key: "ai_assist",
    price: "$99",
    period: "/year",
    featured: true,
    notes: [AI_ASSIST_CARD_LEDE, "Includes everything in Free."],
    points: [
      "Up to 20 tournaments per year",
      ...AI_ASSIST_IMPORTS.map((item) => ({
        label: item.cardLabel,
        to: item.to,
      })),
    ],
  },
  {
    name: "Priority",
    key: "priority",
    price: "$149",
    period: "/year",
    notes: ["Includes AI Assist."],
    points: [
      "Unlimited tournaments per year",
      "Email support on weekends",
      "Priority tickets answered first",
      "A setup check before the tournament",
      "Early access to new director features",
    ],
  },
];
